import { api } from 'api/api';
import { PostResponseViewModel } from 'types/post';
import { GetPostsRequest, UpdatePostRequest, CreatePostRequest, PostsResponse } from './types';
import { parametrizeURL } from 'api/utils';

export const POST_URL = 'Post' as const;
export const GET_POSTS_URL = `${POST_URL}/GetAllAsync` as const;
export const ADD_POST_URL = `${POST_URL}/AddAsync` as const;
export const UPDATE_POST_URL = `${POST_URL}/UpdateAsync/{postId}` as const;

export const readPostById = (params: { id: string }) => api.get<PostResponseViewModel>(POST_URL, { params });

export const deletePostById = (data: { id: string }) => api.delete<void>(POST_URL, { data });

export const readPosts = (params: GetPostsRequest) => api.get<PostsResponse>(GET_POSTS_URL, { params });

export const createPost = (body: CreatePostRequest) => api.post<PostResponseViewModel>(ADD_POST_URL, body);

export const replacePost = (body: UpdatePostRequest, postId: string) =>
    api.post<PostResponseViewModel>(parametrizeURL(UPDATE_POST_URL, { postId }), body);
